import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/query';
import { apiSlice } from "./api/apiSlice"
import authReducer from '../features/auth/authSlice'
        const store = configureStore({
            reducer: {
               
                [apiSlice.reducerPath]: apiSlice.reducer,
                auth: authReducer
            },
            middleware: (getDefaultMiddleware) =>
                getDefaultMiddleware().concat(apiSlice.middleware),
        });

setupListeners(store.dispatch);
export default store;
